<template>
	<div>
		<b-breadcrumb>Gift types</b-breadcrumb>
		<b-alert :show="!!error" variant="danger">{{error&&(error.error||error.toString())}}</b-alert>
		<b-form-row>
			<b-col cols="4">
				<b-form-select v-model="serviceId" :options="[ { id: 0, name: 'All' }, ...services ]" value-field="id" text-field="name"></b-form-select>
			</b-col>
			<b-col>
				<b-form-input placeholder="Search..." v-model="q" class="mb-2" />
			</b-col>
		</b-form-row>
		<b-table :items="giftTypes" :fields="[{ key: 'service', label: 'Service' },{ key: 'type', label: 'Donation type' }, 'value', 'strings', 'group', { key: 'actions', thClass: 'text-right', tdClass: 'text-right'}]" small striped hover>
			<template #cell(service)="data">
				<b-avatar size="1rem" v-if="data.item.serviceIcon&&data.item.serviceIcon.url" :src="data.item.serviceIcon.url"></b-avatar> {{data.item.service_name}}
			</template>
			<template #cell(type)="data">
				<img v-if="data.item.image && data.item.image.url" :src="data.item.image.url" alt="" style="max-width: 32px; max-height: 32px; float: left">
				<img v-else-if="data.item.image_url" :src="data.item.image_url" alt="" style="max-width: 32px; max-height: 32px; float: left">
				{{data.item.name}}<br />
				<code>{{data.item.gift_type}}</code>
			</template>
			<template #cell(value)="data">
				{{data.item.multiplier&&data.item.multiplier > 1?`${data.item.multiplier}x`:''}}{{data.item.value||''}} {{data.item.currency}}
			</template>
			<template #cell(strings)="data">
				{{data.item.string}}<br />
				{{data.item.string_multi}}
			</template>
			<template #cell(group)="data">
				<b-badge :variant="data.value?'success':'secondary'">{{data.value?'yes':'no'}}</b-badge>
			</template>
			<template #cell(actions)="data">
				<b-button-group size="sm">
					<b-button @click="$refs.editModal.show(data.item)" v-b-tooltip.hover.bottom title="Edit donation event"><b-icon icon="pencil-fill"></b-icon></b-button>
				</b-button-group>
			</template>
		</b-table>
		<pager :per-page="perPage" :skip="skip" :total="total" @change="setPage"></pager>
		<gift-type-edit-modal ref="editModal" @saved="loadGiftTypes()" />
	</div>
</template>

<script>
import Pager from '@/components/Pager.vue';
import GiftTypeEditModal from '@/components/GiftType/Modal/Edit.vue';

export default {
	name: 'GiftTypes',
	components: {
		Pager,
		GiftTypeEditModal,
	},
	data() { return {
		error: null,
		loading: 0,
		services: [],
		giftTypes: [],
		total: 0,
		skip: 0,
		perPage: 10,
		serviceId: null,
		q: undefined,
	}},
	created() {
		this.skip = parseInt(this.$route.query.skip||0)||0;
		this.perPage = parseInt(this.$route.query.perPage||10)||10;
		this.serviceId = parseInt(this.$route.query.serviceId||0)||0;
		this.loadGiftTypes();
		this.loadServices();
	},
	watch: {
		'$route': 'loadGiftTypes',
		q: 'loadGiftTypes',
		serviceId: function(val, oldVal) {
			if(val == this.$route.query.serviceId || val == oldVal) return;
			this.$router.push({ query: { ...this.$route.query, serviceId: val || undefined } });
		}
	},
	methods: {
		setPage($event) {
			this.skip = $event.skip;
			this.perPage = $event.perPage;
			this.$router.push({ query: { ...this.$route.query, skip: $event.skip || undefined, perPage: $event.perPage == 10 ? undefined : $event.perPage } });
		},
		loadServices() {
			this.services = [];
			this.loading++;
			this.$api.get('admin/services').then(services => {
				this.services = services.filter(s => s.capabilities.indexOf('chat') !== -1);
			}, err => this.error = err).finally(() => {
				this.loading--;
			});
		},
		loadGiftTypes() {
			this.loading++;
			this.error = null;
			this.$api.get('giftTypes', { q: this.q||'', serviceId: this.serviceId||'', limit: this.perPage, skip: this.skip }).then(giftTypes => {
				this.giftTypes = giftTypes.results;
				this.total = giftTypes.total;
			}).catch(err => this.error = err).finally(() => this.loading--);
		},
	},
};
</script>
